/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */

import React, { useEffect, useRef, useState } from 'react'
import MainLayout from '../Layouts/Mainlayout'
import OutlineButton from '../MUICustomButton/OutlineButton'
//@ts-ignore
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Autocomplete, FormControl, Grid, InputAdornment, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailSend02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ChartLineData02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { Chart01Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailOpen02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailRemove02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailBlock02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { Cursor02Icon, TimeScheduleStrokeRounded } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { SentStrokeStandard } from '@hugeicons-pro/core-stroke-standard';
import moment from 'moment';
import LineChartComponent from './LineChartComponent';
import BarGraphComponent from './BarGraphComponent';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
//@ts-ignore
import HeatMap from "react-heatmap-grid";

const xLabels = new Array(24).fill(0).map((_, i) => `${i}`);

// Display only even labels
const xLabelsVisibility = new Array(24)
    .fill(0)
    .map((_, i) => (i % 2 === 0 ? true : false));

const yLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const data = new Array(yLabels.length)
    .fill(0)
    .map(() =>
        new Array(xLabels.length).fill(0).map(() => Math.floor(Math.random() * 100))
    );

const dataset = [
    { date: moment(new Date(2025, 0, 1)).format('L'), emailSent: 5, opens: 6, clicks: 9, unsubscribes: 1, complaints: 0 },
    { date: moment(new Date(2025, 0, 2)).format('L'), emailSent: 7, opens: 8, clicks: 6, unsubscribes: 2, complaints: 0 },
    { date: moment(new Date(2025, 0, 3)).format('L'), emailSent: 6, opens: 7, clicks: 5, unsubscribes: 3, complaints: 0 },
    { date: moment(new Date(2025, 0, 4)).format('L'), emailSent: 8, opens: 7, clicks: 2, unsubscribes: 4, complaints: 0 },
    { date: moment(new Date(2025, 0, 5)).format('L'), emailSent: 4, opens: 4, clicks: 4, unsubscribes: 5, complaints: 0 },
    { date: moment(new Date(2025, 0, 6)).format('L'), emailSent: 4, opens: 3, clicks: 7, unsubscribes: 6, complaints: 0 },
    { date: moment(new Date(2025, 0, 7)).format('L'), emailSent: 8, opens: 8, clicks: 3, unsubscribes: 7, complaints: 0 },
    { date: moment(new Date(2025, 0, 8)).format('L'), emailSent: 7, opens: 6, clicks: 5, unsubscribes: 8, complaints: 0 },
    { date: moment(new Date(2025, 0, 9)).format('L'), emailSent: 8, opens: 5, clicks: 2, unsubscribes: 9, complaints: 0 },
    { date: moment(new Date(2025, 0, 10)).format('L'), emailSent: 9, opens: 6, clicks: 3, unsubscribes: 10, complaints: 0 },

];

const domainData = [
    { domainName: 'gmail.com', sent: '10', delivered: '8', open: '5', click: '2' },
    { domainName: 'yahoo.com', sent: '10', delivered: '8', open: '5', click: '2' },
    { domainName: 'outlook.com', sent: '10', delivered: '8', open: '5', click: '2' },
    { domainName: 'healthlinkdimensions.com', sent: '10', delivered: '8', open: '5', click: '2' }
]

const deviceData = [
    { domainName: 'Desktop', sent: '10', delivered: '8', open: '5', click: '2' },
    { domainName: 'Mobile', sent: '10', delivered: '8', open: '5', click: '2' },
    { domainName: 'Tablets', sent: '10', delivered: '8', open: '5', click: '2' },
    { domainName: 'Unknown', sent: '10', delivered: '8', open: '5', click: '2' }
]

const clickData = [
    { domainName: 'xyz.com', sent: '10', delivered: '8', open: '5', click: '2' },
    { domainName: 'test.com', sent: '10', delivered: '8', open: '5', click: '2' },
    { domainName: 'google.com', sent: '10', delivered: '8', open: '5', click: '2' },
    { domainName: 'yahoo.com', sent: '10', delivered: '8', open: '5', click: '2' }
]

const emailClientData = [
    { client: "Web version, Using Chrome", data: "54.3%" },
    { client: "Other", data: "10.6%" },
    { client: "Web version, Using Firefox", data: "9.6%" },
    { client: "QQ Mail, Outlook for Windows", data: "8.5%" },
    { client: "Windows Outlook", data: "6.4%" },
]

const inputLabels: any = [
    { key: "emailSent", label: "Email Sent", color: "#3FCEE1" },
    { key: "opens", label: "Opens", color: "#5FD242" },
    { key: "clicks", label: "Clicks", color: "#4B8DF5" },
    { key: "unsubscribes", label: "Unsubscribes", color: "#3A3A3A" },
    { key: "complaints", label: "Complaints", color: "#F95050" }
];

function ViewTriggerReports(): JSX.Element {

    const [fromDate, setFromDate] = useState<any>()
    const [endDate, setEndDate] = useState<any>()
    const [dashboardDateRange, setDashboardDateRange] = useState<any>()
    const [isDateRangeOpen, setIsDateRangeOpen] = useState<boolean>(false)
    const [alignment, setAlignment] = useState<string>('line');
    const [width, setWidth] = useState<number>(0);

    const dateRangeRef: any = useRef(null);
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const resize = (): void => {
            if (containerRef.current) {
                setWidth(containerRef.current.offsetWidth);
            }
        };

        resize(); // Set on mount

        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    }, []);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars


    const handleDateChange = (): void => {
        setIsDateRangeOpen(true)
        const currentDates = getLast7Days();
        setDashboardDateRange({
            startDate: currentDates.startDate,
            endDate: currentDates.endDate,
            key: 'selection'
        })

        setFromDate(currentDates.startDate)
        setEndDate(currentDates.endDate)
    }

    const getLast7Days = (): any => {
        const now = new Date();
        const endDate = new Date(now); // Today
        const startDate = new Date();
        startDate.setDate(now.getDate() - 6); // Go back 6 days (including today, makes 7 days)

        return {
            startDate,
            endDate
        };
    };

    const handleDateRangeClick = (ranges: any): void => {
        setDashboardDateRange(
            {
                startDate: ranges.selection.startDate,
                endDate: dashboardDateRange.endDate && dashboardDateRange.endDate > ranges.selection.startDate ? ranges.selection.endDate !== dashboardDateRange.endDate && ranges.selection.endDate !== ranges.selection.startDate ? ranges.selection.endDate : dashboardDateRange.endDate : ranges.selection.endDate,
                key: "selection"
            }
        )



        // if (ranges.selection.startDate !== ranges.selection.endDate) {
        //     setIsDateRangeOpen(false)
        //     setFromDate(ranges.selection.startDate)
        //     setEndDate(ranges.selection.endDate)

        //     getDashboardData(ranges.selection.startDate, ranges.selection.endDate)
        // }
    }

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ): void => {
        setAlignment(newAlignment);
    };

    const control = {
        value: alignment,
        onChange: handleChange,
        exclusive: true,
    };

    const today = new Date();
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(today.getDate() - 90);

    const handleBackClick = (): void => {
        console.log("click")
    }

    const domainColumns = [
        {
            name: 'Domain',
            selector: (row: any) => row.domainName,
            width: '35%'
        },
        {
            name: 'Sent',
            selector: (row: any) => row.sent,
        },
        {
            name: 'Delivered',
            selector: (row: any) => row.delivered,
        },
        {
            name: 'Open',
            selector: (row: any) => row.open,
        },
        {
            name: 'Click',
            selector: (row: any) => row.click,
        },
    ]

    const deviceColumns = [
        {
            name: 'Device Type',
            selector: (row: any) => row.domainName,
            width: '35%'
        },
        {
            name: 'Sent',
            selector: (row: any) => row.sent,
        },
        {
            name: 'Delivered',
            selector: (row: any) => row.delivered,
        },
        {
            name: 'Open',
            selector: (row: any) => row.open,
        },
        {
            name: 'Click',
            selector: (row: any) => row.click,
        },
    ]

    const clickColumns = [
        {
            name: 'URL',
            selector: (row: any) => row.domainName,
            width: '35%'
        },
        {
            name: 'Sent',
            selector: (row: any) => row.sent,
        },
        {
            name: 'Delivered',
            selector: (row: any) => row.delivered,
        },
        {
            name: 'Open',
            selector: (row: any) => row.open,
        },
        {
            name: 'Click',
            selector: (row: any) => row.click,
        },
    ]
    return (
        <div className="flex flex-row justify-start">
            <MainLayout>
                <div className="flex justify-between items-center mb-[20px]">
                    <div className='flex gap-x-[30px]'>
                        <h1 className="text-2xl text-title font-semibold">Campaign ID: 123</h1>

                        <div>
                            <FormControl fullWidth>
                                <Autocomplete
                                    options={[]}
                                    // getOptionLabel={(option) => option.label}
                                    // onChange={(event, newValue) => handleTemplateValue(newValue)}
                                    //disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Status"
                                            variant="outlined"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '40px',
                                                    height: '40px',
                                                    width: '200px', // Increased width
                                                },
                                            }}
                                        />
                                    )}
                                    sx={{
                                        '& .MuiAutocomplete-clearIndicator': {
                                            marginRight: '-12px'
                                        },
                                        '& .MuiAutocomplete-input': {
                                            width: '70%'
                                        }
                                    }}

                                />
                            </FormControl>
                        </div>
                        <div >
                            <FormControl className='form-dropdown' fullWidth>
                                <TextField
                                    id="date-range"
                                    label="Date Range"
                                    variant="outlined"
                                    autoComplete='off'
                                    ref={dateRangeRef}
                                    fullWidth
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                                            <HugeiconsIcon
                                                icon={Calendar03Icon}
                                                size={18}
                                                color="#3A3A3A"
                                                strokeWidth={0.5}
                                                onClick={handleDateChange}
                                            />
                                        </InputAdornment>
                                    }}
                                    onChange={handleDateChange}
                                    onFocus={handleDateChange}
                                    // onBlur={() => setIsLastActivityOpen(false)}
                                    value={fromDate && endDate ? `${moment(fromDate).format('MM/DD/YYYY')} - ${moment(endDate).format('MM/DD/YYYY')}` : ""}
                                />
                            </FormControl>
                            {isDateRangeOpen && (
                                <div ref={dateRangeRef} style={{ position: 'absolute', zIndex: '999' }}>
                                    <DateRangePicker
                                        ranges={[dashboardDateRange]}
                                        onChange={handleDateRangeClick}
                                        dateDisplayFormat={'MM/dd/yyyy'}
                                        inputRanges={[]}
                                        color={"#FFF5F6"}
                                        rangeColors={["#D6242C"]}
                                        editableDateInputs={true}
                                        startDatePlaceholder={"MM/DD/YYYY"}
                                        endDatePlaceholder={"MM/DD/YYYY"}
                                        minDate={ninetyDaysAgo}
                                        maxDate={today}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div>
                        <OutlineButton onClick={handleBackClick} type='rounded' color='red' width='230px'>
                            <img src="/assets/images/red-arrow.svg" alt="arrow" width={9} height={8} className="mr-[5px] mt-[1px]" />
                            Back to list trigger overview
                        </OutlineButton>
                    </div>
                </div>
                <div className="flex gap-x-[30px] items-center mb-[20px]">
                    <div className="text-14 text-muted">
                        <span className='font-semibold'>Start:</span> 03/18/2025
                    </div>
                    <div className="text-14 text-muted">
                        <span className='font-semibold'>End:</span> 03/25/2025
                    </div>

                </div>
                <div className='mb-[30px]'>
                    <Grid container spacing={2} columns={14}>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Active Campaigns</div>
                                <div className='box-count'>
                                    <div className='count'>0</div>
                                    <div className='icon bg-[#EDEDFF]'>
                                        <HugeiconsIcon
                                            icon={SentStrokeStandard}
                                            size={24}
                                            color="#6B6BFB"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Sent</div>
                                <div className='box-count'>
                                    <div className='count'>0</div>
                                    <div className='icon bg-[#DBF7FB]'>
                                        <HugeiconsIcon
                                            icon={MailSend02Icon}
                                            size={24}
                                            color="#3FCEE1"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Opens</div>
                                <div className='box-count'>
                                    <div className='count'>0</div>
                                    <div className='icon bg-[#DBF6D4]'>
                                        <HugeiconsIcon
                                            icon={MailOpen02Icon}
                                            size={24}
                                            color="#5FD242"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Clicks</div>
                                <div className='box-count'>
                                    <div className='count'>0</div>
                                    <div className='icon bg-[#E0ECFF]'>
                                        <HugeiconsIcon
                                            icon={Cursor02Icon}
                                            size={24}
                                            color="#4B8DF5"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Unsubscribes</div>
                                <div className='box-count'>
                                    <div className='count'>0</div>
                                    <div className='icon bg-[#F0F0F2]'>
                                        <HugeiconsIcon
                                            icon={MailRemove02Icon}
                                            size={24}
                                            color="#3A3A3A"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Complaints</div>
                                <div className='box-count'>
                                    <div className='count'>0</div>
                                    <div className='icon bg-[#FEDADA]'>
                                        <HugeiconsIcon
                                            icon={MailBlock02Icon}
                                            size={24}
                                            color="#F95050"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>List Triggers</div>
                                <div className='box-count'>
                                    <div className='count'>0</div>
                                    <div className='icon bg-[#EDEDFF]'>
                                        <HugeiconsIcon
                                            icon={TimeScheduleStrokeRounded}
                                            size={24}
                                            color="#183FF7"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>

                <div className='mb-[20px]'>
                    <Grid container spacing={2}>
                        <Grid item xs={7}>
                            <div style={{ height: "400px", }} className='graph-container'>
                                <div className='flex justify-between items-center relative mb-[25px] right-[30px]'>
                                    <div className='graph-title'>Sending overview</div>
                                    <div>
                                        <ToggleButtonGroup size="medium" {...control} aria-label="Medium sizes">
                                            <ToggleButton value="line" aria-label="line">
                                                <HugeiconsIcon
                                                    icon={ChartLineData02Icon}
                                                    size={18}
                                                    color="#3A3A3A"
                                                    strokeWidth={0.2}
                                                />
                                            </ToggleButton>
                                            <ToggleButton value="bar" aria-label="bar">
                                                <HugeiconsIcon
                                                    icon={Chart01Icon}
                                                    size={18}
                                                    color="#3A3A3A"
                                                    strokeWidth={0.2}
                                                />
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>
                                </div>
                                {
                                    alignment === 'line' ? <LineChartComponent dataset={dataset} labels={inputLabels} /> : <BarGraphComponent dataset={dataset} labels={inputLabels} />
                                }

                            </div>
                        </Grid>
                        <Grid item xs={5}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[410px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Email Domains</div>
                                <CustomDataTable
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                    columns={domainColumns}
                                    data={domainData}
                                    pagination
                                //   progressPending={loading}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>

                <div className='mb-[20px]'>
                    <Grid container spacing={2}>
                        <Grid item xs={7}>
                            <div ref={containerRef} className='graph-container mb-[20px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Send time heatmap</div>
                                <HeatMap
                                    xLabels={xLabels}
                                    yLabels={yLabels}
                                    xLabelsLocation={"bottom"}
                                    xLabelsVisibility={xLabelsVisibility}
                                    xLabelWidth={60}
                                    data={data}
                                    squares
                                    height={35}
                                    // onClick={(x: any, y: any) => alert(`Clicked ${x}, ${y}`)}
                                    cellStyle={(background: any, value: any, min: any, max: any, data: any, x: any, y: any) => ({
                                        background: `rgb(220, 5,  3, ${1 - (max - value) / (max - min)})`,
                                        fontSize: "11.5px",
                                        color: "#333",
                                    })}
                                    cellRender={(value: any) => value && <div>{value}</div>}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={5}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[410px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Devices</div>
                                <CustomDataTable
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                    columns={deviceColumns}
                                    data={deviceData}
                                    pagination
                                //   progressPending={loading}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>


                <div className='mb-[20px]'>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[410px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Clicks by URL</div>
                                <CustomDataTable
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                    columns={clickColumns}
                                    data={clickData}
                                    pagination
                                //   progressPending={loading}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[410px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Top email clients</div>
                                {
                                    emailClientData.map((client, index) => {
                                        return (
                                            <div key={index} className="flex justify-between items-center mb-[20px]">
                                                <div className='text-muted text-14'>{client.client}</div>
                                                <div className='text-muted text-14 font-bold'>{client.data}</div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </MainLayout>
        </div>

    )
}

export default ViewTriggerReports